export const styles = {
    container: { padding: 20 },
    title: { marginLeft: '20px' },
    close: { marginLeft: '25%' },
    content: { padding: '0px', backgroundColor: '#f7f7f7', overflow: 'overlay', height: '100vh' }
};